import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID, AfterViewChecked } from '@angular/core';
import { HeaderComponent } from '../common/header/header.component';
import { SidebarComponent } from '../common/sidebar/sidebar.component';
import { CommonModule, Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { RouterOutlet, Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { ToggleService } from '../common/header/toggle.service';
import { UserInfoService } from '../services/user.service';
import { environment } from '../environments/environment';
import { AuthService } from '../services/auth.service';


@Component({
  selector: 'app-main',
  standalone: true,
  imports: [RouterOutlet, CommonModule, SidebarComponent, HeaderComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
  providers: [
    Location, {
        provide: LocationStrategy,
        useClass: PathLocationStrategy
    }
]
})
export class MainComponent implements OnInit, AfterViewChecked {
  title = 'Visual Price Estimator';
  routerSubscription: any;
  location: any;

  constructor(
      public router: Router,
      public toggleService: ToggleService,
      @Inject(PLATFORM_ID) private platformId: object,
      private changeDetector: ChangeDetectorRef,
      private userService: UserInfoService,
      private authService: AuthService
  ) {
      this.toggleService.isToggledSideBar$.subscribe(isToggled => {
          this.isToggled = isToggled;
      });
  }

  ngAfterViewChecked() {
    this.changeDetector.detectChanges();
  }

  // Toggle Service
  isToggled = false;

  // Dark Mode
  toggleTheme() {
      this.toggleService.toggleTheme();
  }

  // Settings Button Toggle
  toggle() {
      this.toggleService.toggleSideBar();
  }

  closeSideBar() {
    if (this.isToggled) {
      this.toggleService.closeSideBar();
    }
  }

  // ngOnInit
  ngOnInit(){
    if (isPlatformBrowser(this.platformId)) {
      this.recallJsFuntions();
    }

    if (this.authService.isLoggedIn()) {
      this.userService.loadUserInfo().subscribe({
        next: user => {
          if (!environment.production) {
            console.log('User info loaded in MainComponent:', user);
          }
        },
        error: err => {
          console.error('Failed to load user:', err);
        }
      });
    } else {
      this.router.navigate(['/']);
    }

  }

  // recallJsFuntions
  recallJsFuntions() {
      this.routerSubscription = this.router.events
          .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
          .subscribe(event => {
          this.location = this.router.url;
          if (!(event instanceof NavigationEnd)) {
              return;
          }
          this.scrollToTop();
      });
  }
  scrollToTop() {
      if (isPlatformBrowser(this.platformId)) {
          window.scrollTo(0, 0);
      }
  }
}
